import { render } from "./Section1.vue?vue&type=template&id=6b945a31&scoped=true"
import script from "./Section1.vue?vue&type=script&lang=js"
export * from "./Section1.vue?vue&type=script&lang=js"

import "./Section1.vue?vue&type=style&index=0&id=6b945a31&lang=scss&scoped=true"

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b945a31"]])

export default __exports__